import { useState } from 'react';

import Button from 'components/shared/Button';
import { useReferralSourceImportStore } from 'stores/referralSourceImportStore';
import PlusIcon from 'svg/PlusIcon';

import UploadReferralSourcesModal from './UploadReferralSourcesModal';

/**
 * The admin upload entry point and its modal. Progress is tracked app-wide by
 * ReferralSourceImportManager, so the outcome still arrives after the admin leaves the page. The
 * caller gates this on adminReferralSourceCreate, so a View Only Olio Admin never sees it.
 */
export default function UploadReferralSourcesButton({ clientId }: { clientId: string }) {
  const [modalOpen, setModalOpen] = useState(false);
  const trackImport = useReferralSourceImportStore((state) => state.trackImport);

  return (
    <>
      <Button variant='primary' onClick={() => setModalOpen(true)} data-testid='upload-referral-sources'>
        <PlusIcon width={14} height={14} />
        Upload Referral Sources
      </Button>

      {modalOpen && (
        <UploadReferralSourcesModal clientId={clientId} onClose={() => setModalOpen(false)} onUploaded={trackImport} />
      )}
    </>
  );
}
